/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/age-1237538': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 5h1v1a1 1 0 002 0V5h1a1 1 0 000-2h-1V2a1 1 0 00-2 0v1h-1a1 1 0 000 2zM7 7v10a1 1 0 002 0V7a1 1 0 00-2 0zm14.6 2a1 1 0 00-.78 1.18 9 9 0 11-7-7 1 1 0 10.4-2A10.8 10.8 0 0012 1a11 11 0 1011 11 10.8 10.8 0 00-.22-2.2A1 1 0 0021.6 9zM11 9v1a3 3 0 00.78 2 3 3 0 00-.78 2v1a3 3 0 003 3h1a3 3 0 003-3v-1a3 3 0 00-.78-2 3 3 0 00.78-2V9a3 3 0 00-3-3h-1a3 3 0 00-3 3zm5 6a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1zm0-6v1a1 1 0 01-1 1h-1a1 1 0 01-1-1V9a1 1 0 011-1h1a1 1 0 011 1z"/>'
  }
})
